<template>
  <woot-button
    variant="smooth"
    class="product--add"
    icon="add"
    size="tiny"
    @click="addProduct"
  >
    {{ $t('CONTACT_PANEL.PRODUCTS.CONVERSATION.ADD_BUTTON') }}
  </woot-button>
</template>

<script>
export default {
  methods: {
    addProduct() {
      this.$emit('add');
    },
  },
};
</script>

<style lang="scss" scoped>
.product--add {
  margin-bottom: var(--space-micro);
  margin-right: var(--space-micro);
}
</style>

